import { render, staticRenderFns } from "./quesTwo.vue?vue&type=template&id=1bb4136a"
import script from "./quesTwo.vue?vue&type=script&lang=js"
export * from "./quesTwo.vue?vue&type=script&lang=js"
import style0 from "./quesTwo.vue?vue&type=style&index=0&id=1bb4136a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports